import React from 'react';
import agnosticStyled from '../../../utils/agnosticStyled.mjs';
import { buildResponsiveCSS } from '../../../utils/css.mjs';

const Container = agnosticStyled `
  display: flex;
  ${props => buildResponsiveCSS('flex', props.flex)};
  ${props => buildResponsiveCSS('align-items', props.alignItems)};
  ${props => buildResponsiveCSS('justify-content', props.justifyContent)};
  ${props => buildResponsiveCSS('flex-direction', props.direction)};
  ${props => buildResponsiveCSS('gap', props.gap)};
  ${props => buildResponsiveCSS('flex-wrap', props.flexWrap)};
  ${props => buildResponsiveCSS('padding', props.padding)};
  ${props => buildResponsiveCSS('margin', props.margin)};
  ${props => buildResponsiveCSS('max-width', props.maxWidth)};
  ${props => buildResponsiveCSS('width', props.width)};
`;
const FlexContainer = ({ alignItems = 'normal', justifyContent = 'normal', direction = 'row', gap = '0', flexWrap = 'nowrap', padding, margin, maxWidth, width, flex, className, children }) => {
    return (React.createElement(Container, { alignItems: alignItems, justifyContent: justifyContent, direction: direction, gap: gap, flexWrap: flexWrap, flex: flex, padding: padding, margin: margin, maxWidth: maxWidth, className: className, width: width }, children));
};

export { FlexContainer as default };
//# sourceMappingURL=FlexContainer.mjs.map
